import { TypeOptions, toast } from "react-toastify";

export const myToast = {
 toast: toast,
 toastWait: ({ type, message }: { type?: TypeOptions; message: string }) => {
  const id = toast(message, {
   autoClose: false,
   type: type ?? "info",
  });
  return () => {
   toast.dismiss(id);
  };
 },
 waitTransaction: () => {
  const id = toast.info("Waiting for transaction confirmation...", {
   autoClose: false,
  });
  return () => {
   toast.dismiss(id);
  };
 },
};
